export default __webpack_public_path__ + "static/media/no_more_chasing_kids.2f48edca.svg";